import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../index.css";
import { useTranslation } from "react-i18next";
import HeidiLogo from "../assets/HEIDI_Logo_Black.png";
import Alert from "../Components/Alert";
import { completeUserProfile } from "../Services/usersApi";
import { role } from "../Constants/role";

const WelcomePage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [input, setInput] = useState({
        username: "",
        name: "",
        phoneNumber: "",
        roleId: role.User,
    });

    const [alertInfo, setAlertInfo] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("");
    const [loading, setLoading] = useState(false);

    const validatePhoneNumber = (phoneNumber) => {
        const phoneRegex = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s/0-9]{0,10}$/g;
        return phoneNumber === "" || phoneRegex.test(phoneNumber);
    };

    const onInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "phoneNumber") {
            const isValid = validatePhoneNumber(value);
            if (isValid) {
                setInput((prev) => ({
                    ...prev,
                    [name]: value,
                }));
                setError((prev) => ({
                    ...prev,
                    phoneNumber: "",
                }));
            }
        } else {
            setInput((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        try {
            await completeUserProfile(input);
            navigate("/");
        } catch (error) {
            const errorCode = error.response?.data?.errorCode;
            const apiMessage = error.response?.data?.message;
            let message = t("registraionFailed");

            if (errorCode === 2001) {
                message = t("invalidUserName");
            }
            else if (errorCode === 2005) {
                message = t("usernameExists");
            }
            else if (apiMessage === "Phone number is not valid") {
                message = t("phoneNumValidation");
            }

            setAlertInfo(true);
            setAlertType("danger");
            setAlertMessage(message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="h-screen w-screen bg-white flex justify-center items-center">
            <div className="grid gap-8">
                <div className="rounded-[20px] bg-white shadow-[0_3px_10px_rgb(0,0,0,0.2)] p-10 m-2">
                    <div>
                        <img
                            onClick={() => navigate("/")}
                            className="mx-auto h-20 w-auto cursor-pointer"
                            src={HeidiLogo}
                            alt="HEIDI Logo"
                        />
                        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-slate-800">
                            {t("welcome")}
                        </h2>
                    </div>
                    <div className="mt-8 space-y-6">
                        <div className="space-y-2 rounded-md shadow-sm">
                            <input
                                type="text"
                                id="username"
                                name="username"
                                value={input.username}
                                autoComplete="on"
                                onChange={onInputChange}
                                required
                                className="border p-3 bg-white text-gray-800 border-gray-700 shadow-md placeholder:text-base duration-300 border-gray-300 rounded-lg w-full"
                                placeholder="Enter Username *"
                            />
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={input.name}
                                onChange={onInputChange}
                                required
                                className="border p-3 bg-white text-gray-800 border-gray-700 shadow-md placeholder:text-base duration-300 border-gray-300 rounded-lg w-full"
                                placeholder="Enter Name *"
                            />
                            <input
                                type="text"
                                id="phoneNumber"
                                name="phoneNumber"
                                value={input.phoneNumber}
                                onChange={onInputChange}
                                required
                                className="border p-3 bg-white text-gray-800 border-gray-700 shadow-md placeholder:text-base duration-300 border-gray-300 rounded-lg w-full"
                                placeholder="Enter Phone Number *"
                            />
                        </div>

                        {alertInfo && (
                            <div className="py-2 mt-1 px-2">
                                <Alert type={alertType} message={alertMessage} />
                            </div>
                        )}

                        <button
                            onClick={handleSubmit}
                            type="button"
                            className="bg-gradient-to-r font-md text-gray-300 from-gray-700 to-slate-600 shadow-lg p-2 text-white rounded-lg w-full hover:scale-105 hover:from-gray-700 hover:to-slate-600 transition duration-300 ease-in-out"
                            disabled={loading}
                        >
                            {loading ? "Processing..." : "Continue"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WelcomePage;